























































import Vue from 'vue'
import {Component, Prop} from 'vue-property-decorator'
import {ILeaderboardResult} from '@/entities'
import ComparisonBar from '@/components/ComparisonBar.vue'
import {getCDNUrl} from '@/utils/cdn'

@Component<ScorecardRankRow>({
    components: {ComparisonBar}
})
export default class ScorecardRankRow extends Vue {
    getCDNUrl = getCDNUrl

    @Prop(Number) public rankNum !: number
    @Prop(Number) public minValue !: number
    @Prop(Number) public maxValue !: number
    @Prop(Number) public companyNps !: number
    @Prop(Boolean) public active !: boolean
    @Prop(Boolean) public isLast !: boolean
    @Prop(Boolean) public isFiveScoreQuestionType !: boolean
    @Prop(String) public avatar !: string
    @Prop() public rank !: ILeaderboardResult

    public get ratingLabel() {
        return this.isFiveScoreQuestionType ? 'Rating' : 'NPS'
    }
}
